import * as React from 'react';

function SvgFileEarmarkWord(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M5.485 6.879a.5.5 0 10-.97.242l1.5 6a.5.5 0 00.967.01L8 9.402l1.018 3.73a.5.5 0 00.967-.01l1.5-6a.5.5 0 00-.97-.242l-1.036 4.144-.997-3.655a.5.5 0 00-.964 0l-.997 3.655L5.485 6.88z' />
			<path d='M14 14V4.5L9.5 0H4a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2zM9.5 3A1.5 1.5 0 0011 4.5h2V14a1 1 0 01-1 1H4a1 1 0 01-1-1V2a1 1 0 011-1h5.5v2z' />
		</svg>
	);
}

export default SvgFileEarmarkWord;
